var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectoryActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6 8.4V1.6H9.4V8.4H2.6ZM1 1C1 0.447716 1.44772 0 2 0H10C10.5523 0 11 0.447715 11 1V9C11 9.55228 10.5523 10 10 10H2C1.44772 10 1 9.55229 1 9V1ZM13 13C13 12.4477 13.4477 12 14 12H22C22.5523 12 23 12.4477 23 13V21C23 21.5523 22.5523 22 22 22H14C13.4477 22 13 21.5523 13 21V13ZM18 10C20.7614 10 23 7.76142 23 5C23 2.23858 20.7614 0 18 0C15.2386 0 13 2.23858 13 5C13 7.76142 15.2386 10 18 10ZM11.0913 20.4855L6.8575 13.4292C6.46909 12.7818 5.53091 12.7818 5.14251 13.4292L0.9087 20.4855C0.508785 21.152 0.988898 22 1.76619 22H10.2338C11.0111 22 11.4912 21.152 11.0913 20.4855Z",
    fill: "#005CE6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectoryActive);
export default __webpack_public_path__ + "static/media/directory_active.dcc7a82874dd716dc9937c62222dd859.svg";
export { ForwardRef as ReactComponent };